export const SIMPLE_CELL = 'SimpleCell';
export const TEXT_CELL = 'TextCell';
export const AXIS_CELL = 'AxisCell';
export const BLANK_CELL = 'BlankCell';
export const GEOM_CELL = 'GeomCell';

